import styled from 'styled-components'
import { LocationIcon } from '@/assets/icons'

export const CardContainer = styled.div`
	background: white;
	border-radius: 8px;
	padding: 16px;
	margin-bottom: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	transition: all 0.2s;
	cursor: pointer;
	border: 1px solid #e1e5e9;
	min-width: 0;
	overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 16px;
	flex-shrink: 0;

	&:hover:not(:has(a:hover)) {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		transform: translateY(-1px);
	}
`

export const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`

export const CardTitle = styled.h3`
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	color: #111827;
	flex: 1;
`

export const CardActions = styled.div`
	display: flex;
	gap: 8px;
`

export const ActionButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	font-size: 18px;
	padding: 4px;
	opacity: 0.6;
	transition: opacity 0.2s;

	&:hover {
		opacity: 1;
	}
`

export const CardDescription = styled.p`
	font-size: 14px;
	color: #6b7280;
	line-height: 1.5;
`

export const CardLocation = styled.div`
	font-size: 14px;
	color: #374151;
`

export const LocationPin = styled(LocationIcon)`
	display: inline-block;
	margin-right: 0.5rem;
	vertical-align: middle;
`

export const CardLinks = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	cursor: default;
	pointer-events: auto;
	position: relative;
	z-index: 1;
`

export const LinkPreviewCard = styled.a<{ $clickable?: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	background: #f9fafb;
	text-decoration: none;
	transition: all 0.2s;
	cursor: ${({ $clickable }) => ($clickable === false ? 'default' : 'pointer')};
	overflow: hidden;

	&:hover {
		background: #f3f4f6;
		border-color: #f97316;
		transform: translateX(2px);
	}
`

export const LinkThumbnail = styled.div<{ src?: string }>`
	width: 60px;
	height: 60px;
	min-width: 60px;
	border-radius: 6px;
	background: ${props => props.src ? `url(${props.src})` : '#e5e7eb'};
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`

export const LinkInfo = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 4px;
`

export const LinkSource = styled.div<{ $color?: string }>`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 12px;
	font-weight: 600;
	color: ${({ $color }) => $color ?? '#6b7280'};
	text-transform: capitalize;
`

export const LinkUrl = styled.div`
	font-size: 13px;
	color: #3b82f6;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const CardLink = styled.a`
	font-size: 14px;
	color: #3b82f6;
	text-decoration: none;
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
	cursor: pointer;
	transition: color 0.2s;

	&:hover {
		color: #f97316;
	}
`

export const CardTags = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	margin-top: 12px;
`

export const Tag = styled.span`
	background-color: #e5e7eb;
	color: #374151;
	padding: 4px 12px;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 500;
`
